import * as getUsersByCurrentShipper from "./getUsersByCurrentShipper";

export const transforms = { ...getUsersByCurrentShipper };
